 import { CountryCodeResolver } from './../employees/services/employeeWorkExperience.resolver.service';
 import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import { ContractorListByBusinessResolver, ContractorEditByResolver, ModuleListResolver} from './services/contractor.resolver';
import { AppSharedModule } from './../shared/appShared.module';
import { SubContractorServices } from './services/contractor.service';
import { NgModule } from '@angular/core';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { SubContractorComponent } from './contractor.component';
import { SubContractorListComponent } from './components/sub-contractor-list.component';
import { SubContractorNewComponent } from './components/sub-contractor-new.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PasswordValidatorModule } from 'src/app/shared/password-validator/password-validator.module';

@NgModule({ exports: [
        SubContractorComponent,
        SubContractorListComponent,
        SubContractorNewComponent
    ],
    declarations: [
        SubContractorComponent,
        SubContractorListComponent,
        SubContractorNewComponent
    ], imports: [PasswordValidatorModule,
        AppSharedModule,
        RouterModule,
        TranslatePipe, TranslateDirective,
        KubaExportModule
    ],
    providers: [
        SubContractorServices,
        ContractorListByBusinessResolver,
        CountryCodeResolver,
        ContractorEditByResolver,
        ModuleListResolver,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class SubContractorModule { }
